import React from 'react';
import './style.css';
import { useSelector } from 'react-redux';

function TicketSection() {
  const data = [
    {
      id: 0,
      button: 'open',
      hash: '#487441',
      title: 'Can’t login my account ...',
      time: '5 hours ago',
    },
    {
      id: 1,
      button: 'open',
      hash: '#487441',
      title: 'Can’t login my account ...',
      time: 'February 11, 2014',
    },
    {
      id: 2,
      button: 'open',
      hash: '#487441',
      title: 'Can’t login my account ...',
      time: '5 hours ago',
    },
    {
      id: 3,
      button: 'open',
      hash: '#487441',
      title: 'Can’t login my account ...',
      time: 'February 11, 2014',
    },

  ];

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div className="TeamTicket-Main-Container">
      <div className="Team-Group-Main-Container">
        <p className="Team-Group-Heading">{t.TEAMTICEKT}</p>
        <p className="Team-Group-Link">{t.VIEWALL}</p>
      </div>
      <div>
        {data.map((item) => (
          <div className="Team-Ticket-Main" key={item.id}>
            <div className="Team-Ticket01">
              <button className="grouphas-button" type="button">{item.button}</button>
              <div>
                <p className="hashtext">{item.hash}</p>
                <p className="hashtitle">{item.title}</p>
              </div>
            </div>
            <p className="tickettime">{item.time}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TicketSection;
